import React, { useEffect, useState } from 'react';

const roleName = (role) => {
  switch (role) {
    case 1: return 'Trader';
    case 2: return 'Trader / Manager';
    case 3: return 'Admin';
    default: return 'User';
  }
};

const roleBoxClass = (role) => {
  switch (role) {
    case 3: return 'bg-blue-800 border-blue-500';
    case 2: return 'bg-purple-800 border-purple-500';
    case 1: return 'bg-green-800 border-green-500';
    default: return 'bg-dark-700 border-dark-600';
  }
};

const TreeNode = ({ node }) => {
  const [expanded, setExpanded] = useState(true);
  const hasChildren = node.children && node.children.length > 0;

  return (
    <div className="inline-flex flex-col items-center">
      {/* Node box */}
      <div className="flex items-center gap-2">
        {hasChildren && (
          <button
            onClick={() => setExpanded(!expanded)}
            className="w-6 h-6 flex items-center justify-center rounded bg-dark-700 text-white text-xs"
            title={expanded ? 'Collapse' : 'Expand'}
          >
            {expanded ? '-' : '+'}
          </button>
        )}
        {!hasChildren && <div className="w-6" />}
        <div className={`px-3 py-2 border rounded-md shadow-sm text-white text-sm text-center ${roleBoxClass(node.userRole)}`}>
          <div className="font-medium">{node.userFirstName} {node.userLastName}</div>
          <div className="text-xs opacity-80">{roleName(node.userRole)}</div>
        </div>
      </div>

      {/* Connectors and children row */}
      {hasChildren && expanded && (
        <div className="w-full flex flex-col items-center">
          {/* vertical line under node */}
          <div className="w-px h-4 bg-dark-600"></div>
          {/* children container with top horizontal line */}
          <div className="relative">
            <div className="absolute left-0 right-0 top-0 h-px bg-dark-600" />
            <div className="flex items-start gap-6 pt-2">
              {node.children.map((child) => (
                <div key={child.userId} className="relative flex flex-col items-center">
                  {/* vertical line from horizontal bar to child */}
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-4 bg-dark-600"></div>
                  <div className="pt-4">
                    <TreeNode node={child} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const UserTree = ({ onGetUserTree }) => {
  const [tree, setTree] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const result = await onGetUserTree();
        if (result.success !== false && Array.isArray(result)) {
          setTree(result);
        } else if (result && result.data) {
          setTree(result.data);
        } else {
          setTree([]);
        }
      } catch (e) {
        setTree([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [onGetUserTree]);

  return (
    <div className="space-y-4 overflow-x-auto">
      <div className="flex items-center justify-between">
        <h3 className="text-xl sm:text-2xl font-semibold text-white">User Tree</h3>
        <button
          onClick={() => {
            // simple reload
            const fn = async () => {
              setLoading(true);
              try {
                const result = await onGetUserTree();
                if (result.success !== false && Array.isArray(result)) {
                  setTree(result);
                } else if (result && result.data) {
                  setTree(result.data);
                } else {
                  setTree([]);
                }
              } finally {
                setLoading(false);
              }
            };
            fn();
          }}
          className="bg-dark-700 text-dark-200 px-3 py-2 rounded-lg text-sm hover:bg-dark-600"
        >
          Refresh
        </button>
      </div>

      <div className="bg-dark-800 border border-dark-700 rounded-xl p-4 sm:p-6 shadow-lg min-w-max">
        {loading ? (
          <div className="text-dark-400">Loading tree...</div>
        ) : tree.length === 0 ? (
          <div className="text-dark-400">No users found</div>
        ) : (
          <div className="flex items-start gap-6">
            {tree.map((root) => (
              <TreeNode key={root.userId} node={root} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserTree;


